export const orderCompleteCreateAccount = (form) => {
	if ($('#createAccountForm #submit-create-account').length > 0) {
		if (Dillards.belowFoldFinished) {
			dataLayer.page.formName = 'registrationCheckout';
		} else {
			$(window).on('belowfoldfinished', function () {
				dataLayer.page.formName = 'registrationCheckout';
			});
		}

		$('#submit-create-account').on('click', function () {
			if ($('#createAccountForm').data('validForm') == true) {
				$('#confirm-email-address').val($('#logonId').val());
				$('#email1').val($('#logonId').val());
				$.ajax({
					type: 'POST',
					url: '/webapp/wcs/stores/servlet/UserRegistrationAdd',
					dataType: 'html',
					data: $('#createAccountForm').serialize(),
					success: function (html, textStatus) {
						if (html.indexOf('ForgotPasswordView') > -1) {
							$('#forgotPasswordError').removeClass('hidden');
							$('#createAccountError').addClass('hidden');
							$('html, body').animate({
								scrollTop: $("#forgotPasswordError").offset().top
							}, 700);
						} else if (html.indexOf('errors') > -1) {
							$('#createAccountError').html($(html).find('#errors').html());
							$('#forgotPasswordError').addClass('hidden');
							$('#createAccountError').removeClass('hidden');
							$(".close").hide();
							$('#createAccountError').removeClass('hidden');
							$('html, body').animate({
								scrollTop: $("#createAccountError").offset().top
							}, 700);
						} else {
							$('#viewMyAccount').removeClass('hidden');
							$('#forgotPasswordError,#createAccountError,.createAccount').addClass('hidden');
							try { $(document).trigger('registrationCompleteEvent'); } catch (e) {}
							$('html, body').animate({
								scrollTop: $("#viewMyAccount").offset().top
							}, 700);
						}
						return false;
					},
					error: function (jqXHR, textStatus, errorThrown) {
						$('#forgotPasswordError').addClass('hidden');
						$('#createAccountError').removeClass('hidden');
						return false;
					},
				});
			}
		});

		$('span.passwordRequirements').on('click', function () {
			$('.forgot-password #password-strength').toggleClass('open');
		});
	}
};
